// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"error-message-component_rootContainer__2HayT","container":"error-message-component_container__1JEoj"};